var _path, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyWorkplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,44a.7502.7502,0,0,0,.75.75h3.25V68h1.5V44.75h34.5V68h1.5V60.75h14.5V68h1.5V44.75H70a.7502.7502,0,0,0,.75-.75V38a.7502.7502,0,0,0-.75-.75H64.75V30a.7502.7502,0,0,0-.75-.75H60.75V28A3.25377,3.25377,0,0,1,64,24.75v-1.5a4.72162,4.72162,0,0,0-3.25,1.30432V24A4.7554,4.7554,0,0,0,56,19.25v1.5A3.25377,3.25377,0,0,1,59.25,24v5.25H56a.7502.7502,0,0,0-.75.75v7.25H32.75v-2.5H48A2.7528,2.7528,0,0,0,50.75,32V14A2.7528,2.7528,0,0,0,48,11.25H16A2.7528,2.7528,0,0,0,13.25,14V32A2.7528,2.7528,0,0,0,16,34.75H31.25v2.5H10a.7502.7502,0,0,0-.75.75Zm56,15.25H50.75v-6.5h14.5Zm0-8H50.75v-6.5h14.5Zm-8.5-20.5h6.5v6.5h-6.5ZM14.75,14A1.25116,1.25116,0,0,1,16,12.75H48A1.25116,1.25116,0,0,1,49.25,14V29.25H14.75ZM16,33.25A1.25116,1.25116,0,0,1,14.75,32V30.75h34.5V32A1.25116,1.25116,0,0,1,48,33.25Zm-5.25,5.5h58.5v4.5H10.75Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 48,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 56,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 64,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyWorkplace);
export default __webpack_public_path__ + "static/media/icon_my_workplace.c901683db9cefe1114e36eaa43e462cc.svg";
export { ForwardRef as ReactComponent };